// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"3d881cc4","599":"78fc8cf4","689":"0a85961d","735":"d98e4a80"}[chunkId] + ".chunk.js";
};